import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock, UserPlus, LogIn, Check } from "lucide-react";

export default function AuthGateModal({ open, onOpenChange, nextPath }) {
  const navigate = useNavigate();
  const go = (path) => {
    onOpenChange(false);
    const q = nextPath ? `?next=${encodeURIComponent(nextPath)}` : "";
    navigate(`${path}${q}`);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-md border border-[#D1D5DB] p-0" data-testid="auth-gate-modal">
        <div className="flex items-center gap-3 rounded-t-md bg-[#1F3A68] px-5 py-4 text-white">
          <Lock size={20} />
          <DialogHeader className="space-y-0 text-left">
            <DialogTitle className="font-serif text-lg text-white">Create a free account to access all Revision Kits</DialogTitle>
          </DialogHeader>
        </div>
        <div className="px-5 pb-5 pt-4">
          <DialogDescription className="text-sm text-gray-600">
            All Revision Kits are completely free — you just need a free account to view and download them.
          </DialogDescription>
          <ul className="mt-4 space-y-2 text-sm text-gray-700">
            {["Unlimited access to every subject-wise kit", "New kits added every week", "Save your download history in your dashboard"].map((f) => (
              <li key={f} className="flex items-start gap-2">
                <Check size={16} className="mt-0.5 shrink-0 text-[#16A34A]" /> {f}
              </li>
            ))}
          </ul>
          <div className="mt-5 flex flex-col gap-2">
            <Button onClick={() => go("/register")} className="w-full rounded-sm bg-[#FF9933] font-semibold text-slate-900 hover:bg-[#E68A2E]" data-testid="gate-register-btn">
              <UserPlus size={16} className="mr-2" /> Create Free Account
            </Button>
            <Button onClick={() => go("/login")} variant="outline" className="w-full rounded-sm border-[#1F3A68] text-[#1F3A68] hover:bg-[#1F3A68] hover:text-white" data-testid="gate-login-btn">
              <LogIn size={16} className="mr-2" /> I already have an account
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
